import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { Resident } from "@graphql/api";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}
export default function CommunityDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Community Name",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.community?.name ?? "N/A"}
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Community Portfolio",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.community?.portfolio?.name ?? "N/A"}
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "CT-MHCID",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.community?.ctmhcId ?? "N/A"}
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Portfolio Internal Community Mapping Code",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.community?.propertyId ?? "N/A"}
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Covertree Portfolio ID",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.community?.portfolio.id ?? "N/A"}
              height={28}
              width={150}
            />
          ),
        },
      ]}
    />
  );
}
